/* BeeMax pickers on phones: the flavor buttons and the picture should fit on one screen together.
   This measures how tall the buttons are (from the first label above them to the last button) and stores it as --fit-h
   on the section; the stylesheets size the picture with it. Used by bmx-picker, bmx-sticks and bmx-fillings.
   It also stores where the home slider starts (--sl-top), so the slider can fill the screen below the header. */
(function () {
  'use strict';
  if (window.bmxFit) return;
  var TOP = '.bmx-sticks__choc, .bmx-sticks__pick, .bmx-fill__pick';
  var LIST = '.bmx-chips';
  function fit(sec) {
    var tops = sec.querySelectorAll(TOP), list = sec.querySelector(LIST);
    if (!list || !tops.length) { sec.style.setProperty('--fit-h', '0px'); return; }
    var t = Infinity;
    for (var i = 0; i < tops.length; i++) {
      var r = tops[i].getBoundingClientRect();
      if (r.height > 4) t = Math.min(t, r.top);
    }
    var b = list.getBoundingClientRect().bottom;
    if (t === Infinity) t = list.getBoundingClientRect().top;
    sec.style.setProperty('--fit-h', Math.max(0, Math.round(b - t)) + 'px');
  }
  var ro = 'ResizeObserver' in window ? new ResizeObserver(function (entries) {
    entries.forEach(function (e) { var s = e.target.closest('.bmx-sticks, .bmx-fill'); if (s) fit(s); });
  }) : null;
  function boot(root) {
    (root || document).querySelectorAll('.bmx-sticks, .bmx-fill').forEach(function (s) {
      fit(s);
      var l = s.querySelector(LIST);
      if (ro && l) ro.observe(l);
    });
  }
  // Home slider on computers: it fills the screen below the bar and header. Store where it starts as --sl-top (read by bmx-slider.css).
  // A slider further down a page keeps the stylesheet's default.
  function slTop() {
    document.querySelectorAll('.bmx-sl').forEach(function (s) {
      var t = Math.round(s.getBoundingClientRect().top + window.scrollY);
      if (t >= 0 && t < 400) s.style.setProperty('--sl-top', t + 'px'); else s.style.removeProperty('--sl-top');
    });
  }
  function all(root) { boot(root); slTop(); }
  window.bmxFit = boot;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); }); else all();
  window.addEventListener('load', function () { all(); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(slTop);
  // The bar and header change height at some screen widths: measure again when they do, and shortly after a resize.
  if ('ResizeObserver' in window) {
    var hro = new ResizeObserver(function () { slTop(); });
    document.querySelectorAll('.bmx-header, .bmx-ticker').forEach(function (el) { hro.observe(el); });
  }
  var rt;
  window.addEventListener('resize', function () { if (!ro) boot(); slTop(); clearTimeout(rt); rt = setTimeout(slTop, 200); });
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
})();
